export const Fallback = url =>
  `${DLG.config.distResourcePath}/assets/images/fallback/${url}`;

export const tr = true;
